import { Box, Grid, pn, Stack, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
  PotentialStudentFilter as PotentialStudentFilterModel,
  StudentFilterResource,
  ExportResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const PotentialStudentFilter = (props: {
  exportResource: ExportResource;
  filter: PotentialStudentFilterModel;
  setFilter: (filter: PotentialStudentFilterModel) => void;
}) => {
  const { breakpointsRef, largeFieldBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentFilterResource>({} as StudentFilterResource);
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.students.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const schoolYearField = () => {
    const propertyName = pn<PotentialStudentFilterModel>("schoolYears");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        label="School Year"
        multiple
        modelProperty={property}
        value={props.exportResource.potentialStudentSchoolYears!.filter((x) => props.filter.schoolYears?.includes(x))}
        getOptionLabel={(option) => option}
        options={props.exportResource.potentialStudentSchoolYears}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolYears = values.map((x) => x);
            })
          )
        }
      />
    );
  };

  const termField = () => {
    const propertyName = pn<PotentialStudentFilterModel>("terms");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        label="Terms"
        multiple
        modelProperty={property}
        value={props.exportResource.potentialStudentTerms!.filter((x) => props.filter.terms?.includes(x))}
        options={props.exportResource.potentialStudentTerms}
        getOptionLabel={(option) => option}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.terms = values.map((x) => x);
            })
          )
        }
      />
    );
  };

  return (
    <Stack ref={breakpointsRef} spacing="lg">
      <Box>
        <Grid container spacing="sm">
          <Grid item xs={largeFieldBreakpoints}>
            {schoolYearField()}
          </Grid>
          <Grid item xs={largeFieldBreakpoints}>
            {termField()}
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};
